<template >
    <div :class="['work-single',checked ? 'bg-deep-gray' : '']"
         v-if="firstAttr"
         @click="lookimg(index)">

      <div :class="['work-image flex-vc',firstAttr.exif.type==3?item.bg:'','work-image-'+firstAttr.exif.type]" >
        <template v-if="firstAttr.exif.type<3">
          <div class="work-bg" :style="{background:'url('+firstAttr.comurl+') center center / contain no-repeat'}"></div>

        </template>
        <template v-else-if="firstAttr.exif.type==3">
          <div class="font-size14 black-font work-font">{{firstAttr.exif.text}}</div>
        </template>
        <template v-else-if="firstAttr.exif.type==4">
          <div class="work-bg" style="padding-top: 55px;">
            <img :src="firstAttr.comurl" style="width: 60px;height: 60px;display: block;margin: 0 auto 15px;">
            <div class="font-size16 font-bold font-more-two" style="width: 180px;text-align: center;opacity: .8;margin: 0 auto;">{{firstAttr.exif.name}}</div>
          </div>
        </template>
        <template v-else-if="firstAttr.exif.type==5">
          <div class="work-bg audio" :style="{'background-image':'url('+firstAttr.comurl+')'}"></div>
        </template>
        <div class="bg-black smooth white-font image-count font-size12" v-if="item.materialList.length>1" :style="{right:item.right+'px',bottom:item.bottom+'px'}">{{item.materialList.length}}</div>
        <div :class="['work-check flex-cm',checked ? 'bg-green' : 'bg-white']" @click.stop="selectsingle()" :style="{opacity:checked ? 1 : 0}">
          <img  :src="checked ? 'https://assets.pfotoo.com/pc/img/right-white.svg' : 'https://assets.pfotoo.com/pc/img/right-gray.svg'" style="width:20px;height:20px;"/>
        </div>
        <div class="icon-video-play-container" v-if="firstAttr.exif.type==2">
          <div class="icon-video-play"></div>
        </div>
      </div>
      <div :class="['work-info','black-font']">
        <div class="font-size12 work-name">编号：{{item.serialNumber}}</div>
        <div class="font-size14 work-name font-more" v-if="item.submissionName">{{item.submissionName}}</div>
        <div class="font-size12 font-more" v-if="item.autograph">{{item.autograph}}</div>
      </div>
      <div class="work-hide white-font font-size12" v-if="item.status==1">已隐藏</div>
      <div class="act-cover black-font font-size14" @click.stop="closefun" :style="{display: item.action ? 'block' : 'none',}">
        <div class="act-list flex-vl bg-white">
          <div class="act-single flex-lm" style="position: relative;" @mouseenter="showgroup" @mouseleave="hidegroup">
            <img src="https://assets.pfotoo.com/pc/img/add-gray.svg" style="width: 14px;"/>
            <span>添加到评选相册</span>
            <div :class="['act-modal',item.isselect==true ? 'bg-deep-gray' : 'bg-white','font-size14']" >
              <div v-for="(itemgroup,indexgroup) in grouplist" :class="['modal-group-single font-more',item.isselect==true ? (itemgroup.remove==true ? 'red-font' : 'white-font') : (itemgroup.remove==true ? 'red-font' : 'black-font')]"  @click.stop="itemgroup.remove==true ? deletephoto(itemgroup.id,indexgroup) : addphoto(itemgroup.id,indexgroup)">{{itemgroup.remove==true ? '从'+itemgroup.name+'中移除' : itemgroup.name}}</div>
            </div>
          </div>
          <!-- <div class="act-single">下载</div> -->
          <div class="act-single flex-lm" @click.stop="hidework" style="padding-left: 14px;">
            <img src="https://assets.pfotoo.com/pc/img/hide-gray.svg" style="width: 16px;margin-right: 7;"/>
            <span>{{item.status==1 ? '取消' : ''}}隐藏作品</span>
          </div>
          <div class="act-single flex-lm" @click.stop="delwork" style="padding-left: 13px;">
            <img src="https://assets.pfotoo.com/pc/img/delete-gray.svg" style="width: 18px;margin-right: 6px;"/>
            <span>删除作品</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else="" :class="['work-single',item.isselect==true ? 'bg-deep-gray' : '']">....</div>
</template>

<script>
  import App from '../util/comfun'
export default {
    name: 'work',
    props:{
      item:Object,
      index:Number,
      type:Number,
    },
    data () {
      return {
         grouplist:[],
         openid:JSON.parse(localStorage.getItem('userinfo')).openid,
        firstAttr:null,
        checked:false,
      }
    },
    watch: {
      item(newVal,oldVal){
        console.log('watch.item',newVal,oldVal)
        this.init()
      },
    },
    methods:{
      init(){
        let images=JSON.parse(JSON.stringify(this.item.materialList))
        if(!images || images.length<1) {
          return;
        }
        let firstAttr=images[0]
        if(typeof firstAttr.exif=='string'){
          try{firstAttr.exif=JSON.parse(firstAttr.exif)}catch (e){firstAttr.exif={}}
        }
        if(typeof firstAttr.coverInfo=='string'){
          try{firstAttr.coverInfo=JSON.parse(firstAttr.coverInfo)}catch (e){firstAttr.coverInfo={}}
        }
        firstAttr.url=firstAttr.url||firstAttr.exif.url
        //console.log('firstAttr.exif.'+this.index,JSON.stringify(firstAttr))
        App.setPlayerUrl(firstAttr)
        switch (firstAttr.exif.type/1){
          case 1:
            if (Number(firstAttr.exif.size) > 20 * 1024 * 1024 && !firstAttr.hasTransed) {
              firstAttr.comurl = firstAttr.playerUrl;
            } else {
              firstAttr.comurl = firstAttr.playerUrl + '?imageMogr2/format/webp/thumbnail/750x/quality/100!/ignore-error/1';
            }
            break;
          case 2:
            firstAttr.comurl = firstAttr.url + '?vframe/jpg/offset/1/w/' + firstAttr.exif.width + '/h/' + firstAttr.exif.height;
            if(firstAttr.coverInfo && firstAttr.coverInfo.url){
              firstAttr.comurl=firstAttr.coverInfo.url;
            }
            break;
          case 3:
            break;
          case 4:
            firstAttr.comurl='https://assets.pfotoo.com/file/' + firstAttr.exif.mark + '.svg';
            break;
          case 5:
            firstAttr.comurl = firstAttr.coverInfo.url + '?imageMogr2/thumbnail/100000@';
            break;
        }
        //this.item.images=images
        this.firstAttr=firstAttr
        //this.item.sign=this.item.autograph
        //this.item.ishide=this.item.status
      },
      lookimg(index){
        this.$emit('tellworkidx',index);
      },
      selectsingle(flag=null){
        console.log('selectsingle',typeof flag)
        if(typeof flag == 'boolean'){
          this.checked=flag
        }else{
          this.checked=!this.checked
        }
        this.$emit('selectwork',{submissionId:this.item.submissionId,index:this.index,checked:this.checked})
      },
      getgroup(){
        this.$http({
          url:'https://pfotoo.com?s=App.Contribution.GetGroupByContribution'+this.$getsign(),
          params:{
            cid:this.item.cid,
          },
          method:'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          console.log(res.body,'uuuuuuuuu')
          let json=res.body;
          if(res.body.ret==200){
             // this.grouplist=json.data;
             this.autogroup=json.data;
          }
        })
      },
      getworkdetail(){
        this.$http({
          url:'https://pfotoo.com?s=App.Works.GetWorksById'+this.$getsign(),
          params:{
            submissionId:this.item.submissionId,
            openid:this.openid
          },
          method:'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          console.log(res.body)
          let json=res.body;
          if(res.body.ret==200){
            console.log(json.data.groups,'uuuuuuuuuuuu');
            let groups=json.data.groups,grouplist=this.autogroup;
            groups.forEach((v,i)=>{
              grouplist.forEach((r,n)=>{
                if(v.id==r.id){
                  r.remove=true;
                }
                // this.$set(this.grouplist,n,r);
              })
            })
            this.grouplist=grouplist;
            console.log(this.grouplist)
          }
        })
      },
      showfun(){
        console.log('rrrrrr')
        this.$set(this.item,'action',true);
        console.log(this.item)
        this.$emit('editmodal',{id:this.item.submissionId,index:this.index});
        this.getworkdetail();
      },
      closefun(){
        console.log('rrrrrr')
        this.$set(this.item,'action',false);
      },
      showgroup(){
        $('.act-modal').addClass('active');
      },
      hidegroup(){
        $('.act-modal-mask').removeClass('active');
        $('.act-modal').removeClass('active');
      },
      //从添加到相册
      addphoto(gid,index){
        console.log('dddddd',gid,this.item)
        this.$http({
          url:'https://pfotoo.com?s=App.Contribution.InsertGroup'+this.$getsign(),
          params:{
            wid:this.item.submissionId,
            gid:gid
          },
          method:'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          console.log(res.body)
          let json=res.body;
          if(res.body.ret==200){
            this.grouplist[index].remove=true;
            this.$set(this.grouplist,index,this.grouplist[index]);
            this.$message({
                message: '添加成功',
                type: 'success'
            });
          }
          this.hidegroup();
          this.closefun();
        })
      },
      //从相册移除
      deletephoto(gid,index){
        this.$http({
          url:'https://pfotoo.com?s=App.Contribution.DeleteByGroup'+this.$getsign(),
          params:{
            workid:this.item.submissionId,
            groupid:gid
          },
          method:'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          console.log(res.body)
          let json=res.body;
          if(res.body.ret==200){
            this.grouplist[index].remove=false;
            this.$set(this.grouplist,index,this.grouplist[index]);
            this.$message({
                message: '已移除',
                type: 'success'
            });
          }
          this.hidegroup();
          this.closefun();
        })
      },
      //隐藏投稿
      hidework(){
        let parmdata={
          submissionIdList:[this.item.submissionId],
        }
        if(this.item.status==1){
          parmdata.type=1;
        }
        this.$http({
          url:'https://pfotoo.com?s=App.Contribution.SetEventHide'+this.$getsign(),
          params:parmdata,
          method:'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          console.log(res.body)
          let json=res.body;
          if(res.body.ret==200){
            this.item.status=parmdata.type ? 0 : 1;
            this.$set(this.item,'status',this.item.status);
            this.$message({
                message: parmdata.type ? '已取消' : '已隐藏',
                type: 'success'
            });
          }
          this.closefun();
        })
      },
      delwork(){
        this.$confirm('此操作将永久删除该投稿, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.$http({
            url:'https://pfotoo.com?s=App.Works.DelWorks'+this.$getsign(),
            params:{
              id:this.item.submissionId,
            },
            method:'POST',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then((res)=>{
            console.log(res.body)
            let json=res.body;
            if(res.body.ret==200){
              this.$message({
                 message: '删除成功',
                 type: 'success'
              });
              this.$emit('del')
            }
            this.closefun();
          })
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
          this.closefun();
        });
      },
    },
    mounted(){
      //this.getgroup();
      this.init()
    },
  }
</script>

<style>
  .work-single {
      width: 200px;
      margin: 0 10px 50px 20px;
      cursor: pointer;
      -webkit-box-shadow: 0 0 2px 1px rgba(224,223,223,.5);
      box-shadow: 0 0 2px 1px rgba(224,223,223,.5);
      position: relative;
      top: 0;
      -webkit-transition: top .3s ease,-webkit-box-shadow .3s ease;
      transition: top .3s ease,-webkit-box-shadow .3s ease;
      transition: box-shadow .3s ease,top .3s ease;
      transition: box-shadow .3s ease,top .3s ease,-webkit-box-shadow .3s ease;
  }
  .work-single:hover{
    top:4px;
    box-shadow:4px 8px 16px 2px rgba(224,223,223,.8);
    /* background:#bbc3c9; */
  }
  .act-cover{
    width: 160px;
    height: 140px;
    position: absolute;
    left: 120px;
    top: 303px;
    /* transition: width .2s linear; */
   /* overflow: hidden; */
    -webkit-box-shadow: 0 0 2px 1px rgba(224,223,223,.5);
    box-shadow: 0 0 2px 1px rgba(224,223,223,.5);
    z-index: 2;
  }
  /* .act-cover.active{
    width: 100%;
  } */
  .act-list{
    width: 100%;
    height: 100%;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .act-single{
    width: 100%;
    height: 40px;
    padding: 0 15px;
    box-sizing: border-box;
  }
  .act-single:hover{
      background: #EEF2F2;
  }
  .act-single img{
    margin-right: 8px;
  }
  .act-modal-mask{
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    /* background: rgba(0,0,0,.5); */
    overflow: hidden;
    height: 0 ;
  }
  .act-modal-mask.active{
    height: 100%;
  }
  .act-modal{
    width: 120px;
    position: absolute;
    left: 100%;
    top: 0;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    -webkit-box-shadow: 0 0 2px 1px rgba(224,223,223,.5);
    box-shadow: 0 0 2px 1px rgba(224,223,223,.5);
    padding: 10px 0;
    box-sizing: border-box;
    display: none;
  }
  .act-modal.active{
    display: block;
  }
  .modal-group-single{
    width: 100%;
    height: 40px;
    text-align: center;
    line-height: 40px;
  }
  .modal-group-single:hover{
    background: #EEF2F2;
  }
  /* .work-single:hover .work-info{
    color: #ffffff;
  } */
  .bg-deep-gray{
    /* background:#bbc3c9; */
    box-shadow:4px 8px 16px 2px rgba(224,223,223,.8);
  }
  .work-single:hover .work-check{
    opacity: 1!important;
    border: 1px solid #eee;
  }
  .work-single.bg-deep-gray:hover .work-check{
    border: 0;
  }

  /* .work-single:hover .act-modal{
    background:#bbc3c9;
  } */
  /* .work-single:hover .modal-group-single{
    color: #fff;
  } */
  /* .work-single .modal-group-single:hover{
    color:#3DC4A7;
  } */
  .work-image {
      width: 100%;
      height: 240px;
      position: relative;
  }
  .work-bg {
      width: 100%;
      height: 100%;
  }
  .work-info {
      width: 100%;
      padding: 20px 10px 10px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
  }
  .work-name {
      font-weight: 500;
      margin-bottom: 5px;
      line-height: 20px;
  }
  .image-count {
      position: absolute;
      right: 5px;
      bottom: 5px;
      padding: 2px 4px;
      opacity: .7;
      border-radius: 1px;
  }
  .work-check{
      width: 20px;
      height: 20px;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: 0;
  }
  .work-hide{
    padding: 0 5px;
    line-height: 20px;
    position: absolute;
    left:0;
    top:0;
    background: rgba(0,0,0,.5);
  }
  .work-more{
    padding: 10px 10px 7px;
    position: absolute;
    bottom: 0;
    right: 0;
  }
  .circle{
    width: 3px;
    height: 3px;
    border-radius:50%;
    margin-bottom: 3px;
  }
  .work-font{
    width:100%;
    white-space:pre-wrap;
    /* text-align: center; */
    padding: 0 20px;
    box-sizing: border-box;
    line-height: 1.6;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 8;
    overflow: hidden;
  }
  .work-image-5{
    width: 200px;
    height: 200px;
  }
  .audio{
    width: 70%;
    height: 70%;
    margin: 15% 15%;
    box-shadow: 0px 1px 4px 1px #9cc5ad;
    border-radius: 50%;
    background-size: cover;
  }
  .icon-video-play-container{
    position: absolute;
    left:50%;
    top:50%;
  }
  .icon-video-play{
    width:50px;
    height:50px;
    background:url('https://assets.pfotoo.com/PC/play@3x.png') no-repeat center center / contain;
    position:absolute;
    
    margin-left:-25px;
    margin-top:-25px;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/work.vue